export default function CEnums() {
  return <h2>C Enums</h2>;
}
